import { AxiosInstance } from 'axios'
import axiosInstance from '.'

class SignApi {
  private axios: AxiosInstance

  constructor(axios: AxiosInstance) {
    this.axios = axios
  }

  public async updateMandatStatus(eid: string) {
    this.axios.post(`sign/${eid}/check`)
  }
}

export const signApi = new SignApi(axiosInstance)
